import React from 'react'

import { Section } from './index.styled'

const FadeOutSection = ({ open, children }) => {
  return <Section className={open ? 'opened' : ''}>{children}</Section>
}

export default FadeOutSection
